<template>
  <div class="top-left-cmp">
    <div class="dc-left" style="width: 40%">
      <dv-border-box-5 style="height: 30%;">
        <div class="main-value" style="margin-top: 10px"><span style="font-size: 24px">{{workOrderDetail.workOrderCode}}</span></div>
      </dv-border-box-5>
      <div class="dc-text" style="align-items: unset; margin-top: -15px">
        当前工单概览
        <dv-decoration-6 style="width:180px; height:20px;" />
      </div>
    </div>
    <div class="dc-right" style="width: 60%">
      <!--<div class="dc-text">
        当前工单概览
        <dv-decoration-3 style="width:200px;height:20px;" />
      </div>-->
      <dv-border-box-5 :reverse="true">
        <div class="compare-value"><span style="font-size: 18px; color: #00c0ff">{{workOrderDetail.materialCode}}</span><span style="font-size: 14px; color: orange">{{workOrderDetail.materialSource == 89 ? "星纵物联" : "星纵数字"}}</span></div>
        <div class="compare-value"><span style="color: #00c0ff">{{workOrderDetail.materialName}}</span></div>
        <div class="compare-value" style="font-size: 14px; color: #00c0ff; word-break: break-all">{{workOrderDetail.materialModel}}</div>
        <div class="compare-value" style="font-size: 14px; color: #00c0ff">数量：{{workOrderDetail.orderNumber}}</div>
      </dv-border-box-5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopLeftCmp',
  data () {
    return {
      workOrderDetail: {},
      lineId: undefined
    }
  },
  beforeMount(){
    const href = window.location.href
    const str = href.substr(href.indexOf("?")+1,href.length)
    const params = str.split('&')
    const code = params[0].split('=')[1]
    if (code){
      this.lineId = code;
    }
  },
  mounted () {
    const { getBigScreen } = this;
    getBigScreen();
    setInterval(getBigScreen, 10000);
  },
  methods: {
    async getBigScreen() {
      const data = await this.$http.post('https://apismt.moxitech.cn/admin-api/bigScreen/getWorkOrderDetail',{
        lineId: this.lineId
      }).then(res=>{
        return res.data.data
      }).catch(e=>{
        console.log(e)
      });
      this.workOrderDetail = data;
    }
  }
}
</script>

<style lang="less">
.top-left-cmp {
  display: flex;

  .dc-left, .dc-right {
    width: 50%;
  }

  .dv-border-box-5 {
    height: 60%;
  }

  .dc-text {
    display: flex;
    flex-direction: column;
    height: 40%;
    font-size: 20px;
    padding: 20px;
    box-sizing: border-box;
  }

  .dc-left .dc-text {
    align-items: flex-end;
    justify-content: center;
  }

  .dc-right .dc-text {
    justify-content: flex-start;
    padding-top: 20px;
  }

  .dc-left .dv-border-box-5 {
    padding: 30px;
    box-sizing: border-box;
  }

  .dc-right .dv-border-box-5 {
    padding: 40px;
    padding-left: 75px;
    box-sizing: border-box;
  }

  .main-value {
    font-weight: bold;
    font-size: 24px;

    span {
      font-size:30px;
      color: #00c0ff;
      margin-right: 15px;
    }
  }

  .compare-value {
    height: 36px;
    line-height: 36px;
    font-size: 18px;

    span {
      margin-right: 30px;
    }
  }
}
</style>
